import { DarkVenueHeatmapRequest } from 'widgets/darkVenueHeatmap/store/data/DarkVenueHeatmapRequest.ts';
import { DarkVenueHeatmapApiRequest } from 'widgets/darkVenueHeatmap/api/DarkVenueHeatmapApiRequest.ts';
import { SymbolsService } from 'symbols/SymbolsService.ts';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState.ts';

export const toApiRequest = async (
    request: DarkVenueHeatmapRequest,
    symbolsService: SymbolsService
): Promise<DarkVenueHeatmapApiRequest> => {
    const { symbol, symbology } = request;

    const instinetSymbol = await symbolsService.convertSymbol(
        symbol,
        symbology,
        SymbologyValues.Instinet
    );

    if (!instinetSymbol) {
        throw new Error(
            'No instinet symbol found for request' +
                request.symbology +
                '/' +
                request.symbol
        );
    }

    return { instinetSymbol };
};
